module.exports = __webpack_public_path__ + "img/广州冷库.74718f0a.jpg";